// src/api/modules/LiquidationApi.js
import Methods from "../methods";

const loadLiquidationList = (context, payload) => {
  const url = `api/liquidation?${payload.params}`
  return Methods.doGet(context, url, null)
}

const saveLiquidationList = (context, payload) => {
  const url = `api/liquidations/generate/${payload.idClient}/${payload.month}/${payload.year}`
  return Methods.doPost(context, url, payload, null)
}

const saveLiquidationDetailList = (context, payload) => {
  const url = `api/liquidations/byfecha`
  return Methods.doPost(context, url, payload, null)
}

const saveService = (context, payload) => {
  const url = `api/liquidations/generateManual/${payload.idClient}/${payload.codeService}/${payload.description}/${payload.price}/${payload.amount}`
  return Methods.doPost(context, url, payload, null)
}

const generateLiquidation = (context, payload) => {
  const url = `api/liquidation/generate`;
  return Methods.doPost(context, url, payload.filters, null)
}

const saveLiquidation = (context, payload) => {
  const url = `api/liquidation/saveliquidation/${payload.param.idCliente}/${payload.param.startDate}/${payload.param.endDate}`;
  return Methods.doPost(context, url, payload.param.list, null)
}

const exportLiquidation = (context, payload) => {
  const url = `api/liquidation/exportliquidation/${payload.param.idLiquidation}/${payload.param.type}`;
  return Methods.doPostDonwload(context, url, {extExport: payload.param.type}, `reporte-liquidacion-${payload.param.nameClient}`, null)
}

const deleteLiquidation = (context, payload) => {
  const url = `api/liquidation/${payload.param.id}`;
  return Methods.doDelete(context, url, null)
}

const sendLiquidationToOdoo = (context, payload) => {
  const {idLiquidation} = payload;
  const url = `api/odoo/send/${idLiquidation}`;
  return Methods.doPost(context, url, {}, null);
};

export default {
  loadLiquidationList,
  saveLiquidationList,
  saveLiquidationDetailList,
  saveService,
  generateLiquidation,
  exportLiquidation,
  saveLiquidation,
  deleteLiquidation,
  sendLiquidationToOdoo
}



// WEBPACK FOOTER //
// ./src/api/modules/LiquidationApi.js